import React, { Component } from "react";
import {
  message,
  Row,
  Col,
  Spin,
  Select,
  Switch,
  Tooltip,
  Form as FormInicial,
} from "antd";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import axios from "axios";
import { connect } from "react-redux";
import {
  PlusOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const { Option } = Select;

const MODOS_ACTUALIZACION = [
  { value: "manual", label: "Manual" },
  { value: "directo", label: "Automático - Tipo de cambio directo" },
  { value: "cantidad", label: "Automático - Tipo de cambio + cantidad" },
  { value: "porcentaje", label: "Automático - Tipo de cambio + porcentaje" },
];

class MonedasConfiguracion extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoMonedas: null,
    todasMonedas: [],
  };

  componentDidMount() {
    this.consultarConfiguracion();
  }

  async consultarConfiguracion() {
    this.setState({ loading: true });
    await axios
      .post(
        "monedas/selectMonedas",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) return;
        this.setState({
          todasMonedas: res.data,
          objetoMonedas: res.data.map((value) => (
            <Option value={value._id} key={value._id}>
              {value.nombre + " - " + value.abreviacion}
            </Option>
          )),
        });
      });
    await axios
      .post(
        "empresas/selectConfiguracionMonedas",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          this.formRef.current.setFieldsValue({ monedas: [] });
          return;
        }
        this.formRef.current.setFieldsValue({
          monedas: Array.isArray(res.data.monedas) ? res.data.monedas : [],
        });
      })
      .catch(() => {
        this.formRef.current.setFieldsValue({ monedas: [] });
      });
    this.setState({ loading: false });
  }

  onFinish(values) {
    const monedas = values.monedas || [];
    const ids = monedas.map((m) => m && m.monedaId).filter(Boolean);
    if (ids.length !== new Set(ids).size) {
      message.error("No se puede repetir la misma moneda");
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "empresas/editarConfiguracionMonedas",
        { empresaId: this.props.empresaId, monedas },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha modificado la configuración de monedas");
          this.consultarConfiguracion();
        } else if (res.data.success === 1) {
          message.error("No se pudo modificar la configuración de monedas");
        } else {
          message.error("Hubo un error y no se modificó la configuración");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Hubo un error y no se modificó la configuración");
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    return (
      <Spin spinning={this.state.loading}>
        <Form
          name="monedasConfiguracion"
          layout
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
          ref={this.formRef}
          initialValues={{ monedas: [] }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24}>
              <DynamicCardForm
                title={
                  <span>
                    Monedas habilitadas{" "}
                    <Tooltip title="Seleccione las monedas que utilizará la empresa, defina el tipo de cambio inicial y elija la forma en que se actualizará cada día.">
                      <InfoCircleOutlined style={{ color: "#00BFD6" }} />
                    </Tooltip>
                  </span>
                }
                style={{ maxWidth: "98%", margin: "0 auto 12px auto" }}
              >
                <FormInicial.List name="monedas">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.length === 0 ? (
                        <p
                          style={{
                            textAlign: "center",
                            color: "#999",
                            margin: "10px 0 16px",
                            fontSize: 13,
                          }}
                        >
                          Aún no se han agregado monedas
                        </p>
                      ) : null}

                      <Row gutter={[16, 16]}>
                        {fields.map(({ key, name, fieldKey, ...restField }) => (
                          <Col xs={24} md={12} lg={8} key={key}>
                            <FormItem shouldUpdate noStyle>
                              {({ getFieldValue }) => {
                                const monedaId = getFieldValue([
                                  "monedas",
                                  name,
                                  "monedaId",
                                ]);
                                const monedaSel = this.state.todasMonedas.find(
                                  (m) => m._id === monedaId
                                );
                                const abreviacion = monedaSel
                                  ? monedaSel.abreviacion
                                  : "—";
                                const nombreMoneda = monedaSel
                                  ? monedaSel.nombre
                                  : "Sin moneda seleccionada";
                                const modo = getFieldValue([
                                  "monedas",
                                  name,
                                  "modoActualizacion",
                                ]);
                                return (
                                  <div
                                    style={{
                                      border: "1px solid #e8e8e8",
                                      borderRadius: 10,
                                      background: "#fff",
                                      boxShadow:
                                        "0 1px 4px rgba(0, 191, 214, 0.08)",
                                      overflow: "hidden",
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <div
                                      style={{
                                        background:
                                          "linear-gradient(135deg, #00BFD6 0%, #0098AD 100%)",
                                        color: "#fff",
                                        padding: "12px 14px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          lineHeight: 1.1,
                                          overflow: "hidden",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: 22,
                                            fontWeight: 700,
                                            letterSpacing: 1,
                                          }}
                                        >
                                          {abreviacion}
                                        </span>
                                        <span
                                          style={{
                                            fontSize: 11,
                                            opacity: 0.9,
                                            marginTop: 2,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {nombreMoneda}
                                        </span>
                                      </div>
                                      <ButtonItem
                                        rojo2
                                        icon={<DeleteOutlined />}
                                        onClick={() => remove(name)}
                                        lessTime
                                      />
                                    </div>

                                    <div style={{ padding: "14px 14px 4px" }}>
                                      <FormItem
                                        {...restField}
                                        label="Moneda"
                                        name={[name, "monedaId"]}
                                        fieldKey={[fieldKey, "monedaId"]}
                                        required
                                        margin
                                        labelCol={{ span: 10 }}
                                        wrapperCol={{ span: 14 }}
                                      >
                                        <SelectItem placeholder="Moneda">
                                          {this.state.objetoMonedas}
                                        </SelectItem>
                                      </FormItem>

                                      <FormItem
                                        {...restField}
                                        label="Tipo de cambio"
                                        name={[name, "tipoDeCambio"]}
                                        fieldKey={[fieldKey, "tipoDeCambio"]}
                                        required
                                        number
                                        margin
                                        labelCol={{ span: 10 }}
                                        wrapperCol={{ span: 14 }}
                                      >
                                        <InputNumberItem
                                          placeholder="Tipo de cambio"
                                          dinero
                                        />
                                      </FormItem>

                                      <FormItem
                                        {...restField}
                                        label="Actualización"
                                        name={[name, "modoActualizacion"]}
                                        fieldKey={[
                                          fieldKey,
                                          "modoActualizacion",
                                        ]}
                                        required
                                        margin
                                        initialValue="manual"
                                        labelCol={{ span: 10 }}
                                        wrapperCol={{ span: 14 }}
                                      >
                                        <SelectItem placeholder="Modo">
                                          {MODOS_ACTUALIZACION.map((m) => (
                                            <Option
                                              value={m.value}
                                              key={m.value}
                                            >
                                              {m.label}
                                            </Option>
                                          ))}
                                        </SelectItem>
                                      </FormItem>

                                      {modo === "cantidad" ? (
                                        <FormItem
                                          {...restField}
                                          label="Cantidad"
                                          name={[name, "ajuste"]}
                                          fieldKey={[fieldKey, "ajuste"]}
                                          required
                                          number
                                          margin
                                          labelCol={{ span: 10 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputNumberItem
                                            placeholder="Cantidad a sumar"
                                            dinero
                                          />
                                        </FormItem>
                                      ) : null}

                                      {modo === "porcentaje" ? (
                                        <FormItem
                                          {...restField}
                                          label="%"
                                          name={[name, "ajuste"]}
                                          fieldKey={[fieldKey, "ajuste"]}
                                          required
                                          number
                                          margin
                                          labelCol={{ span: 10 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputNumberItem
                                            placeholder="% a aplicar"
                                            porcentaje
                                          />
                                        </FormItem>
                                      ) : null}
                                    </div>
                                  </div>
                                );
                              }}
                            </FormItem>
                          </Col>
                        ))}
                      </Row>

                      <div
                        style={{
                          textAlign: "center",
                          marginTop: 18,
                          maxWidth: 320,
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <ButtonItem
                          cyan
                          type="primary"
                          onClick={() =>
                            add({ modoActualizacion: "manual" })
                          }
                          block
                          icon={<PlusOutlined />}
                        >
                          Agregar Moneda
                        </ButtonItem>
                      </div>
                    </>
                  )}
                </FormInicial.List>

                <Row style={{ marginTop: 18 }}>
                  <Col xs={24}>
                    <FormItem
                      label="Actualizar tipos de cambio diariamente"
                      name="actualizarDiario"
                      valuePropName="checked"
                      tooltip="Si se activa, las monedas con modo automático se recalcularán cada día con el tipo de cambio oficial."
                      margin
                      labelCol={{ xs: { span: 24 }, md: { span: 10 } }}
                      wrapperCol={{ xs: { span: 24 }, md: { span: 4 } }}
                    >
                      <Switch />
                    </FormItem>
                  </Col>
                </Row>
              </DynamicCardForm>
            </Col>
          </Row>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "12px 8px",
              borderTop: "1px solid #f0f0f0",
              flexShrink: 0,
            }}
          >
            <ButtonItem
              cyan
              type="primary"
              htmlType="submit"
              style={{
                minWidth: 120,
                height: 30,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Guardar Configuración
            </ButtonItem>
          </div>
        </Form>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(MonedasConfiguracion);
